import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { brandsApi } from '@/features/brands/api';
import { queryKeys } from '@/lib/api/queryKeys';
import { Breadcrumbs } from '@/components/ui/Breadcrumbs';
import { HelpHint } from '@/features/help/HelpHint';
import { useT } from '@/lib/i18n/useT';
import { LeftoversTab } from './LeftoversTab';

/**
 * Los sobrantes de una marca: eventos ya terminados que siguen con unidades
 * asignadas en sus estaciones. Cada fila lleva al cierre del evento, que es
 * donde se cuentan, se devuelven al almacén y queda el acta. Cuando todos
 * están cerrados, esta página está vacía, que es como debe estar.
 */
export function BrandLeftoversPage() {
  const t = useT();
  const { id } = useParams<{ id: string }>();
  const brandId = Number(id);
  const validId = Number.isFinite(brandId) && brandId > 0;

  const brandQ = useQuery({
    queryKey: queryKeys.brands.detail(brandId),
    queryFn: () => brandsApi.get(brandId),
    enabled: validId,
  });
  const brand = brandQ.data ?? null;

  return (
    <div className="page">
      <div className="mb-4 flex items-center justify-between gap-3">
        <Breadcrumbs
          items={[
            { label: brand?.name ?? t('breadcrumbs.brand'), to: `/brand/${brandId}` },
            { label: t('sidebar.myXotskies'), to: `/brand/${brandId}/xotskies` },
            { label: t('brand.tabs.leftovers') },
          ]}
        />
        <HelpHint section="brand-leftovers" />
      </div>
      <LeftoversTab brandId={validId ? brandId : null} />
    </div>
  );
}
